import { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import queryString from "query-string";
import Button, { BUTTON_TYPE_CLASSES } from "../../button/button.component";
import AuctionCarousel, {
  AUCTION_CAROUSEL_TYPE,
  imgBreakpoints,
} from "../../auctions/auction-carousel/auction-carousel.component";
import {
  CMHeadingContainer,
  CMDetails,
  CMCarouselContainer,
  CMAuctionDescription,
  CMBox,
  CMOffer,
  CMError,
  CMErrorContainer,
  CMAuctionBalance,
} from "./make-offer.styles";

import { getAuctionDetails } from "../../../Services/auction.service";
import InputField from "../../Input-field/input-field.component";
import { getProfile, getWalletBalance } from "../../../Services/prod/auth.service";
import Loading from "../../loading/loading.component";

const MakeOffer = ({ handleNext, values, setActiveStep }) => {
  //const { order } = useParams();
  const [auction, setAuction] = useState({});
  const [status, setStatus] = useState(undefined);
  const [loading, setLoading] = useState(true);

  const [text, setText] = useState("$");
  const location = useLocation();
  const parsedURL = queryString.parse(location.search);
  const order = parsedURL.id;
  const [bidError, setBidError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [balance, setBalance] = useState("");
  const [balanceFee, setBalanceFee] = useState("");
  const initialTotalUnit = auction.minimum_units || values.totalUnit;
  const totalBidString = values?.totalBid || "$0";
  const totalBidStringClear = totalBidString.replace(/[$,]/g, '');
  const totalBidValue = parseFloat(totalBidStringClear) || 0;
  const totalBidWithFee = totalBidValue * ((balanceFee / 100));
  const totalSum = totalBidValue + totalBidWithFee;
  const BidWithFeeRounded = totalBidWithFee.toFixed(2);
  const [isBlocked, setIsBlocked] = useState(false)
  const balanceFeeFormatted = parseFloat(totalSum)?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  const currentPriceStr = auction?.CurrentAuctionPrice
    ? auction?.CurrentAuctionPrice.toString().replace(/[^0-9.]/g, '')
    : "0";
  const currentPrice = parseFloat(currentPriceStr);
  const isValidBidedUnits = (bidedUnits) => {
    if (!bidedUnits || typeof bidedUnits !== "string") {
      return false;
    }
    const [currentStr, totalStr] = bidedUnits.split('/');
    const current = Number(currentStr.replace(/,/g, '')); 
    const total = Number(totalStr.replace(/,/g, ''));
    if (isNaN(current) || isNaN(total)) {
      return false;
    }
    return current >= total;
  };
  const initialBidPerUnit = (isValidBidedUnits(auction?.BidedUnits) ? parseFloat((currentPrice + 0.10).toFixed(2)) : auction.mimimum_price_num) || values.bidPerUnit;

  const getBalance = async (amount) => {
    setLoading(true)
    try {
      const fee = ((balanceFee / 100) * totalBidValue);
      const amountV = parseFloat(amount.replace(/[$,]/g, ''));
      const amountValue = amountV + fee;


      if (balance && parseFloat(balance) !== 0 && amountValue <= parseFloat(balance)) {
        handleNext()
        setLoading(false)
      } else {
        setActiveStep((value) => value + 3
        )
        setLoading(false)
      }
    } catch (error) {
      console.log(error, "error");
      setLoading(false)
    }
  };

  const getToken = async () => {
    try {
      const profileRes = await getProfile();
      setIsBlocked(profileRes?.data?.is_blocked)
    } catch (error) {
      console.error(error.message || "An error occurred In Token & Prifile Section");
    }
  };

  useEffect(() => {

    var error = false;
    var totalUnit_v = 0;
    var bidPerUnit_v = 0;

    if (values.totalUnit !== "") {

      const totalUnit = parseInt(values.totalUnit);
      totalUnit_v = totalUnit

      values.totalUnit = totalUnit === 0 ? initialTotalUnit : totalUnit

      if (totalUnit < auction.minimum_units) {
        setUnitError(`Minimum number of units is ${auction.minimum_units}`);
        error = true;
      } else if (totalUnit > auction.maximum_units) {
        setUnitError(`Maximum number of units is ${auction.maximum_units}`);
        error = true;
      } else {
        setUnitError("")
      }

    } else {
      setUnitError("");
    }

    if (values.bidPerUnit !== "") {

      let bidPerUnit = parseFloat(values.bidPerUnit);
      bidPerUnit_v = bidPerUnit;

      const decimalParts = bidPerUnit.toString().split(".");

      if (decimalParts.length > 1 && decimalParts[1].length > 2) {
        bidPerUnit = Math.floor(bidPerUnit * 100) / 100;
      }

      values.bidPerUnit = bidPerUnit === 0 ? initialBidPerUnit : bidPerUnit
      
      const minPrice = isValidBidedUnits(auction?.BidedUnits)
      ? parseFloat((currentPrice + 0.10).toFixed(2))
        : auction.mimimum_price_num;

      if (bidPerUnit < minPrice) {
        setBidError(`Minimum number of bids per unit is ${minPrice}`);
        error = true;
      } else if (bidPerUnit > auction.maximum_price_num) {
        setBidError(`Maximun number of bids per unit is ${auction.maximum_price_num}`);
        error = true;
      } else {
        setBidError("");
      }

    } else {
      setBidError("");
    }
    
    if (!error) {
      const totalBid = bidPerUnit_v * totalUnit_v;
      values.totalBid = totalBid?.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    } else {
      values.totalBid = "0";
    }

  }, [values.bidPerUnit, values.totalUnit, auction]);

  /* useEffect(() => {
     console.log("inside effect");
     if (values.bidPerUnit !== "" && values.totalUnit !== "") {
       console.log(values.bidPerUnit * values.totalUnit);
       values.totalBid = (values.bidPerUnit * values.totalUnit).toLocaleString(
         "en-US",
         {
           style: "currency",
           currency: "USD",
         }
       );
     } else {
       values.totalBid = "0";
     }
   }, [values.bidPerUnit, values.totalUnit]);
   */

  // const handlebidPerUnitChange = (event) => {
  //   setBidPerUnit(event.target.value);
  // };

  // const handleTotalUnitChange = (event) => {
  //   setTotalUnit(event.target.value);
  // };
  useEffect(() => {
    getToken()
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);


        const [auctionResponse, walletResponse] = await Promise.all([
          getAuctionDetails(order),
          getWalletBalance()
        ]);

        if (auctionResponse) {
          setAuction(auctionResponse);
        }

        if (walletResponse?.data) {
          const newBalance = walletResponse.data;
          setBalance(newBalance[0]?.available_cash);
          setBalanceFee(newBalance[0]?.fees.bid_fee);
        }

      } catch (error) {
        console.log(error, "error");
        setStatus(error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [order]);



  const balanceFormatted = balance
    ? parseFloat(balance)?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    })
    : "";

  const FormattedNumber = (number) => {
    const newFormatted = parseFloat(number)?.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    }).replace('$', '').replace(/\.00$/, '');;

    return newFormatted;
  }


  return (
    <>
      {loading ? (<div style={{ marginRight: "5%" }}><Loading /></div>) :
        <>
          <CMHeadingContainer>
            <h3>
              Auction symbol / <span>{auction.symbol}</span>{" "}
            </h3>
          </CMHeadingContainer>
          <CMDetails className="dotted-border">
            <CMCarouselContainer>
              <AuctionCarousel
                slides={auction.imgSrc || [""]}
                carouselType={AUCTION_CAROUSEL_TYPE.imageSemiRounded}
                breakpoints={imgBreakpoints}
                auctionID={auction.auctionID}
              />
            </CMCarouselContainer>
            <CMAuctionDescription>
              <h3>{auction.assetName}</h3>
            </CMAuctionDescription>
          </CMDetails>
          <CMBox>
            <div className="container">
              <div className="dollar-sign-box column1">
                <label htmlFor="dollar">&nbsp;</label>
                <div className="dollar-sign">$</div>
              </div>

              <div className="column2">
                <label htmlFor="bidPerUnit">Bid per unit<span className="error-caption"> * </span></label>
                <InputField
                  type="number"
                  id="bidPerUnit"
                  name="bidPerUnit"
                  step="0.001"
                  min={auction.mimimum_price_num}
                  max={auction.maximum_price_num}
                  value={values.bidPerUnit || ""}
                />
              </div>
              <section className="titleBids" >
                <label className="titleBidsMin">Min bid</label>
                <label className="titleBidsMax">Max bid</label>
              </section>
              <section className="contentBids">
                <label className="titleBidsMin">{isValidBidedUnits(auction?.BidedUnits) ? "$" + FormattedNumber(currentPrice + 0.10) : auction.minimum_price}</label>
                <label className="titleBidsMax">{auction.maximum_price}</label>
              </section>

              <div className="column3">
                <h3>X</h3>
              </div>
              <div className="column4">
                <label htmlFor="totalUnit">Total units<span className="error-caption"> * </span></label>
                <InputField
                  type="number"
                  id="totalUnit"
                  name="totalUnit"
                  min={auction.minimum_units}
                  max={auction.maximum_units}
                  defaultValue={auction.minimum_units}
                  value={values.totalUnit || ""}
                />
              </div>
              <section className="titleBidsUnits" style={{}}>
                <label className="titleBidsMin">Min unit</label>
                <label className="titleBidsMax">Max Units</label>
              </section>
              <section className="contentBidsUnits">
                <label className="titleBidsMinUnits">{auction.minimum_units ? FormattedNumber(auction.minimum_units) : 0}</label>
                <label className="titleBidsMaxUnits">{auction.maximum_units ? FormattedNumber(auction.maximum_units) : 0}</label>
              </section>
              <div className="column5">
                <h1>=</h1>
              </div>
              <div className="column6">
                <label className="CMTotal">Your total bid</label>
                <label className="fee">+${BidWithFeeRounded}({balanceFee ? balanceFee.toFixed(2) : 0}% fee)</label>
                <label>{balanceFeeFormatted || ""}</label>
              </div>
            </div>

            <div className="table-container">
              <div className="table-wrapper">
                <div className="row minBid">
                  <div className="cell">Min bid</div>
                  <div className="cell">{isValidBidedUnits(auction?.BidedUnits) ? "$" + FormattedNumber(currentPrice + 0.10) : auction.minimum_price}</div>
                </div>
                <div className="row maxBid">
                  <div className="cell">Max bid</div>
                  <div className="cell">{auction.maximum_price}</div>
                </div>
                <div className="row minUnit">
                  <div className="cell">Min unit</div>
                  <div className="cell">{auction.minimum_units ? FormattedNumber(auction.minimum_units) : 0}</div>
                </div>
                <div className="row">
                  <div className="cell">Max Units</div>
                  <div className="cell">{auction.maximum_units ? FormattedNumber(auction.maximum_units) : 0}</div>
                </div>
              </div>
            </div>
          </CMBox>
          <CMErrorContainer>
            <CMError className="error-message">{bidError}</CMError>
            <CMError className="error-message">{unitError}</CMError>
          </CMErrorContainer>
          <CMOffer>
            <CMAuctionBalance>
              <h3 style={{ fontWeight: "normal" }}>Available cash : {balanceFormatted || "$0.00"}</h3>
              <Button
                color="light-green"
                isProgressButton={true}
                loading={loading}
                onClick={() => {
                  getBalance(values.totalBid.replace(/\$/g, ""));
                }}
                disabled={
                  values.bidPerUnit.length == 0 ||
                  values.bidPerUnit == 0 ||
                  values.totalUnit.length == 0 ||
                  values.totalUnit == 0 ||
                  bidError !== "" ||
                  unitError !== "" ||
                  loading || isBlocked
                }
              >
                Submit Your Bid
              </Button>
              {isBlocked ? <p style={{ color: "red", textAlign:"center" }}>Your Account is Blocked, Please contact admin</p>:""}
            </CMAuctionBalance>
          </CMOffer>
        </>
      }

    </>
  );
};
export default MakeOffer;
